export default "__VITE_ASSET__91ef646f__"